import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Brightness1 from "@material-ui/icons/Brightness1";

import { QualificationMapper } from "features/planner/planner.mappers";
import { getQualificationByIdFromState } from "features/planner/planner.selectors";

const QualificationColumn = ({ classes, qualification }) => {
  if (!qualification.get("id")) {
    return null;
  }

  return (
    <Grid container alignItems="center" wrap="nowrap" spacing={1}>
      <Grid item className={classes.iconContainer}>
        <Brightness1 style={{ color: qualification.get("backColor") }} />
      </Grid>
      <Grid item>{qualification.get("name")}</Grid>
    </Grid>
  );
};

const styles = () => ({
  iconContainer: {
    display: "flex",
  },
});

QualificationColumn.defaultProps = {
  qualification: QualificationMapper.initial(),
};

export default compose(
  connect((state, { qualificationId }) => ({
    qualification: qualificationId
      ? getQualificationByIdFromState(state, qualificationId)
      : undefined,
  })),
  withStyles(styles),
)(QualificationColumn);
